import { Component, OnInit, OnDestroy } from "@angular/core";
import { FuseConfigService } from "@fuse/services/config.service";
import { Html5Qrcode, Html5QrcodeScannerState } from "html5-qrcode";
import { Router } from "@angular/router";

@Component({
    selector: "app-scan-charger",
    templateUrl: "./scan-charger.component.html",
    styleUrls: ["./scan-charger.component.scss"],
})
export class ScanChargerComponent implements OnInit, OnDestroy {
    html5QrCode!: Html5Qrcode;
    hasScanned: boolean = false;
    scannerStarted: boolean = false;

    user_id: string | null = "";
    mobile_no: string | null = "";

    constructor(
        private _fuseConfigService: FuseConfigService,
        private router: Router
    ) {
        // Hide layout elements
        this._fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        this.user_id = sessionStorage.getItem("web_user_id");
        this.mobile_no = sessionStorage.getItem("web_mobile");
        
        if (!this.user_id || !this.mobile_no) {
            this.router.navigate(["/web-login"]);
            return;
        }

        this.checkActiveSession();
        // sessionStorage.removeItem("charger_data");
        this.startQRScanner();
    }

    checkActiveSession(): void {
        fetch(
            `https://cmsapi.vmatic.co.in/api-v3/app/chargStation/getActiveSessionbyUserId/${this.user_id}/${this.mobile_no}`
        )
            .then((response) => {
                if (!response.ok) throw new Error("Network error");
                return response.json();
            })
            .then((data) => {
                if (data?.status && data?.data?.[0]?.session_status === "Active") {
                    this.router.navigate(["/charger-status"]);
                }
            })
            .catch((err) => {
                console.error("Session check failed:", err);
            });
    }

    startQRScanner(): void {
        this.html5QrCode = new Html5Qrcode("reader");

        const config = {
            fps: 10,
            qrbox: (width: number, height: number) => {
                const size = Math.max(50, Math.min(width, height) * 0.9); // Ensure at least 50px
                return { width: size, height: size };
            },
            rememberLastUsedCamera: true,
        };

        this.html5QrCode
            .start(
                { facingMode: "environment" },
                config,
                (decodedText: string) => this.handleScanSuccess(decodedText),
                (errorMessage: string) => {
                    // Ignore scan errors
                }
            )
            .then(() => {
                this.scannerStarted = true;
            })
            .catch((err) => {
                console.error("Failed to start QR scanner:", err);
            });
    }

    handleScanSuccess(decodedText: string): void {
        if (this.hasScanned) return;
        this.hasScanned = true;

        console.log("✅ Scanned:", decodedText);

        if (this.html5QrCode && this.scannerStarted) {
            this.html5QrCode
                .stop()
                .then(() => this.html5QrCode.clear())
                .catch((err) => {
                    console.warn("Scanner stop error (already stopped?):", err);
                })
                .finally(() => {
                    sessionStorage.setItem("charger_data", decodedText);
                    this.router.navigate(["/charger-detail"]);
                });
        }
    }

    ngOnDestroy(): void {
        if (this.html5QrCode && this.scannerStarted && !this.hasScanned) {
            this.html5QrCode
                .stop()
                .then(() => this.html5QrCode.clear())
                .catch((err) => {
                    console.warn("Scanner stop error on destroy:", err);
                });
        }
    }
}
